/**
 * Searches all the bids on a shipment and matching the ones that are associated with the user's carriers.
 * Using DOT# in case MC# is null.
 */

import { IShipmentBid } from 'types'
import { IMotorCarrier } from '../types'

export const getUserBids = (
  motorCarriers: IMotorCarrier[],
  shipmentBids: IShipmentBid[]
): IShipmentBid[] => {
  const carriers = motorCarriers.map(mc => mc.dotNumber)
  return shipmentBids.filter(bid => carriers.includes(Number(bid.carrierDotNumber)))
}
